import { Routes } from '@angular/router';
import { DefaultLayoutComponent } from './layout/default-layout/default-layout.component';
import { NetworkSummaryComponent } from './views/department-summary/department-summary.component';
import { DailyVehicleCountComponent } from './views/daily-vehicle-count/daily-vehicle-count.component';
import { DepotLiveSummaryComponent } from './views/region/depot-live-summary/depot-live-summary.component';
import { RepairerDowntimeComponent } from './views/region/repairer-downtime/repairer-downtime.component';
import { DepotInsightsComponent } from './views/region/depot-insights/depot-insights.component';
import { DepotUnutilisedComponent } from './views/region/depot-unutilised/depot-unutilised.component';
import { AuthGuard } from './guards/auth.guard'; // Import the guard
import { RegionSummaryComponent } from './views/region/region-summary/region-summary.component';
import { DepotContainerComponent } from './views/region/depot-container/depot-container.component';
import { AverageTimeRepairerComponent } from './views/region/repairer-downtime/average-time-repairer/average-time-repairer.component';
import { DowntimeRepairerDetailComponent } from './views/region/repairer-downtime/downtime-repairer-detail/downtime-repairer-detail.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '',
    pathMatch: 'full'
  },
  {
    path: '',
    component: DefaultLayoutComponent,
    canActivate: [AuthGuard],
    data: {
      title: 'Home'
    },
    children: [
      {
        path: 'daily-vehicle-count',
        component: DailyVehicleCountComponent,
      },
      {
        path: 'department/:departmentId',
        component: NetworkSummaryComponent,
        pathMatch: "full",
      },
      {
        path: 'department/:departmentId/region/:regionId',
        component: RegionSummaryComponent,
        pathMatch: "full",
      },
      {
        path: 'department/:departmentId/region/:regionId/depot/:depotId',
        component:DepotContainerComponent,
        children: [
          {
            path: '',
            component: DepotLiveSummaryComponent,
          },
          {
            path: 'downtime',
            component: RepairerDowntimeComponent,
            children: [
              {path: '', component: AverageTimeRepairerComponent, pathMatch:'full'},
              {path: 'detail/:repairerId', component: DowntimeRepairerDetailComponent}
            ]
          },
          // {
          //   path: 'insights',
          //   component: DepotInsightsComponent,
          // },
          {
            path: 'unutilised',
            component: DepotUnutilisedComponent,
          }
        ]
      },
      {
        path: 'region/:id/:subRegion',
        component: DepotLiveSummaryComponent,
        children: [
          {
            path: 'downtime',
            component: RepairerDowntimeComponent,
          },
          {
            path: 'insights',
            component: DepotInsightsComponent,
          },
          {
            path: 'unutilised',
            component: DepotUnutilisedComponent,
          }
        ]
      },
    ]
  }
];
